import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { FadeUp } from "../components/Reveal";
import ProjectCard from "../components/ProjectCard";

export default function Projects() {
  const [projects, setProjects] = useState(null);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  const categories = ["All", ...Array.from(new Set((projects || []).map((p) => p.category).filter(Boolean)))];
  const filtered = (projects || []).filter((p) => filter === "All" || p.category === filter);

  return (
    <main className="pt-28 sm:pt-40 px-6 sm:px-10 pb-24 sm:pb-32">
      <div className="max-w-[1400px] mx-auto">
        <FadeUp>
          <p className="flex items-center gap-3 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-[#8A857D]">
            <span className="h-px w-10 bg-[#C29B38]" /> Portfolio
          </p>
          <h1 className="mt-5 font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight">
            Projects<em className="italic text-[#C29B38]">.</em>
          </h1>
          <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.22em] text-[#8A857D]">
            {filtered.length} {filtered.length === 1 ? "work" : "works"}
          </p>
        </FadeUp>

        <FadeUp delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-3" data-testid="project-filters">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`project-filter-${c.toLowerCase()}`}
                onClick={() => setFilter(c)}
                className={`px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] border transition-all duration-300 ${
                  filter === c
                    ? "bg-[#181816] text-[#F8F6F0] border-[#181816]"
                    : "border-[#181816]/20 text-[#57534E] hover:border-[#181816] hover:text-[#181816]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </FadeUp>

        <div className="mt-16 grid md:grid-cols-2 gap-x-10 gap-y-20">
          {filtered.map((p, i) => (
            <FadeUp key={p.id} className={i % 2 === 1 ? "md:mt-24" : ""}>
              <ProjectCard project={p} index={i} aspect={i % 3 === 0 ? "aspect-[4/5]" : "aspect-[4/3]"} />
            </FadeUp>
          ))}
        </div>

        {projects !== null && filtered.length === 0 && (
          <p className="mt-20 font-light text-[#8A857D]">No projects in this category yet — check back soon.</p>
        )}
      </div>
    </main>
  );
}
